<template>
  <header :class="{ stretch: props.stretch }">
    <div
      class="h-18 w-full header-box"
      :class="scrollTop > 0 && 'header-shadow'"
    >
      <div class="container mx-auto h-full flex justify-between">
        <div class="flex justify-between">
          <!-- logo -->
          <div
            class="flex items-center cursor-pointer logo-box mr-25"
            @click="toLinkFunc(`${transpaceDomain}/home`)"
          >
            <img
              src="https://ali-file-cdn.iol8.com/img/logo/pe/iol8-pe_372-96.png"
              alt="logo"
              class="h-16"
            />
          </div>
          <!-- 导航 -->
          <ul class="flex items-center justify-center">
            <li v-for="(item, i) in data" :key="i">
              <a-dropdown :trigger="['hover']" placement="bottom">
                <div
                  class="flex items-center justify-center"
                  @click="toMenuPageFunc(item, item.name)"
                >
                  <span
                    class="font-size-15 text-4e5969 mr-1d25 item-title h-6 leading-6"
                  >
                    {{ item.value }}
                  </span>
                  <img
                    src="https://ali-file-cdn.iol8.com/img/icon/down_32-32.png "
                    width="16"
                    height="16"
                    v-if="item.list && item.list.length > 0"
                  />
                </div>
                <template #overlay>
                  <div class="dropdown-box" v-if="item.list">
                    <div class="flex">
                      <div>
                        <p
                          v-if="item.isTitle"
                          class="text-xs text-4e5969 px-4 mb-3 font-medium"
                        >
                          快速开始
                        </p>
                        <div
                          class="item flex items-center"
                          v-for="(li, j) in item.list"
                          :key="j"
                          @click="toMenuPageFunc(item, li.name)"
                        >
                          <img :src="li.icon" width="48" height="48" />
                          <div class="ml-3">
                            <p class="font-size-15 text-1c2129 font-semibold">
                              {{ li.title }}
                            </p>
                            <p class="text-xs text-86909c mt-1d5">
                              {{ li.description }}
                            </p>
                          </div>
                          <img
                            src="https://ali-file-cdn.iol8.com/img/icon/down_32-32.png "
                            width="16"
                            height="16"
                            class="icon-box"
                          />
                          <div v-if="li.list" class="help-box">
                            <div v-for="(t, i) in li.list" :key="i">
                              <div
                                class="flex items-center justify-between help-item"
                                @click="userToPageFunc(t.name)"
                              >
                                <div
                                  class="h-full flex items-center justify-center text-sm text-1c2129 font-semibold"
                                >
                                  {{ t.title }}
                                </div>
                                <img
                                  src="https://ali-file-cdn.iol8.com/img/icon/down_32-32.png "
                                  width="16"
                                  height="16"
                                  class="help-icon"
                                />
                              </div>
                            </div>
                          </div>
                          <!-- 帮助中心hover补位 -->
                          <div v-if="li.list" class="item item-space"></div>
                        </div>
                      </div>
                      <div
                        class="more-box"
                        v-if="item.more && item.more.length > 0"
                      >
                        <p
                          class="text-xs text-4e5969 font-medium px-4 mb-3 text"
                        >
                          更多
                        </p>
                        <div
                          class="item flex items-center"
                          v-for="(li, j) in item.more"
                          :key="j"
                          @click="toMenuPageFunc(item, li.name)"
                        >
                          <img :src="li.icon" width="48" height="48" />
                          <div class="ml-3">
                            <p class="font-size-15 text-1c2129 font-semibold">
                              {{ li.title }}
                            </p>
                            <p class="text-xs text-86909c mt-1d5">
                              {{ li.description }}
                            </p>
                          </div>
                          <img
                            src="https://ali-file-cdn.iol8.com/img/icon/down_32-32.png "
                            width="16"
                            height="16"
                            class="icon-box"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </a-dropdown>
            </li>
          </ul>
        </div>
        <!-- 登录注册 -->
        <div class="flex items-center justify-center">
          <a-button
            class="height-36 mr-4 border-radius-6"
            @click="userToPageFunc('tsp-dashboard')"
          >
            我的工作台
          </a-button>
          <!-- 已登录 -->
          <div v-if="userStore.trId" class="flex items-center">
            <!-- 项目聊天室 -->
            <ImChat :userId="userStore.trId" />
            <div
              class="msg-box"
              @click="toLinkFunc(`${getTalentDomain()}/message/center`)"
            >
              <img
                src="../assets/image/header/img-msg.png"
                alt=""
                width="18"
                height="18"
              />
              <div
                v-if="
                  valMsgCount.value.unreadWdCount > 0 ||
                  valMsgCount.value.unreadToolCount > 0
                "
                class="red-dot twinkling"
              ></div>
            </div>

            <a-dropdown :trigger="['click']" placement="bottomRight">
              <div class="width-12 height-12 border-radius-50 cursor-pointer">
                <img
                  :src="userInfo.value.imgUrl"
                  alt=""
                  class="w-full h-full border-radius-50 avatar"
                />
              </div>
              <template #overlay>
                <div class="user-box">
                  <div class="info-box flex mb-5">
                    <div class="width-16 height-16 border-radius-50">
                      <img
                        :src="userInfo.value.imgUrl"
                        alt=""
                        class="w-full h-full border-radius-50 avatar"
                      />
                    </div>
                    <div class="ml-4">
                      <div class="flex">
                        <div
                          class="text-1c2129 font-semibold font-size-16 linehight-1d5"
                        >
                          {{ userInfo.value.nickname }}
                        </div>
                      </div>
                      <div class="text-86909c font-size-12 pt-2">
                        {{ userInfo.value.phone || userInfo.value.email }}
                      </div>
                    </div>
                  </div>
                  <!-- <div class="level-box">
                    <div
                      class="level-item"
                      :class="'person-' + userLevel.code"
                      @click="toHome(1)"
                    >
                      <div
                        class="font-size-13 text-333 text-center flex items-center justify-center height-px-16"
                      >
                        <img
                          v-if="userLevel.name == '免费版'"
                          src="../assets/image/header/v0.png"
                          width="16"
                        />
                        <img
                          v-else
                          src="../assets/image/header/v1.png"
                          width="16"
                        />
                        <span class="ml-px-2">个人{{ userLevel.name }}</span>
                      </div>
                      <p
                        class="time text-center mt-px-5"
                        v-if="userLevel.endDate > 0"
                      >
                        {{ dayjs(userLevel.endDate * 1).format('YYYY-MM-DD') }}
                        到期
                      </p>
                      <p class="time text-center mt-px-5" v-else>永久有效</p>
                    </div>
                    <div
                      class="level-item"
                      :class="'team-' + projectLevel.code"
                      @click="toHome(2)"
                    >
                      <p
                        class="font-size-13 text-333 text-center flex items-center justify-center height-px-16"
                      >
                        <img
                          v-if="projectLevel.name == '免费版'"
                          src="../assets/image/header/v0.png"
                          width="16"
                        />
                        <img
                          v-else-if="projectLevel.name == '初创版'"
                          src="../assets/image/header/v1.png"
                          width="16"
                        />
                        <img
                          v-else-if="projectLevel.name == '企业版'"
                          src="../assets/image/header/v2.png"
                          width="16"
                        />
                        <img
                          v-else-if="projectLevel.name == '旗舰版'"
                          src="../assets/image/header/v3.png"
                          width="16"
                        />
                        <span class="ml-px-2">
                          团队{{ projectLevel.name }}
                        </span>
                      </p>
                      <p
                        class="time text-center mt-px-5"
                        v-if="projectLevel.endDate > 0"
                      >
                        {{
                          dayjs(projectLevel.endDate * 1).format('YYYY-MM-DD')
                        }}到期
                      </p>
                      <p class="time text-center mt-px-5" v-else>永久有效</p>
                    </div>
                  </div> -->
                  <div
                    class="info-href height-40 rounded-md flex items-center"
                    @click="userToPageFunc('tsp-dashboard')"
                  >
                    <div class="width-4 height-4 ml-3">
                      <img src="../assets/image/header/user-1.png" alt="" />
                    </div>
                    <div class="ml-3 text-sm text-1c2129">我的工作台</div>
                  </div>
                  <div
                    class="info-href height-40 rounded-md flex items-center"
                    @click="userToPageFunc('wd-jl')"
                  >
                    <div class="width-4 height-4 ml-3">
                      <img src="../assets/image/header/user-2.png" alt="" />
                    </div>
                    <div class="ml-3 text-sm text-1c2129">个人简历</div>
                  </div>
                  <div
                    class="info-href height-40 rounded-md flex items-center"
                    @click="userToPageFunc('wd-set')"
                  >
                    <div class="width-4 height-4 ml-3">
                      <img src="../assets/image/header/user-3.png" alt="" />
                    </div>
                    <div class="ml-3 text-sm text-1c2129">接单设置</div>
                  </div>
                  <div class="line-box"></div>
                  <div
                    class="info-href height-40 rounded-md flex items-center"
                    @click="userToPageFunc('pe-invite-politely')"
                  >
                    <div class="width-4 height-4 ml-3">
                      <img src="../assets/image/header/user-4.png" alt="" />
                    </div>
                    <div
                      class="ml-3 text-sm text-1c2129 flex items-center h-4 justify-center leading-4"
                    >
                      <span class="pr-1d5">邀请好友</span>
                      <div class="width-px-28 height-px-16">
                        <img
                          src="../assets/image/header/user-4-jl.png"
                          alt=""
                          class="width-px-28 height-px-16"
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    class="info-href height-40 rounded-md flex items-center"
                    @click="userToPageFunc('tsp-home')"
                  >
                    <div class="width-4 height-4 ml-3">
                      <img src="../assets/image/header/user-5.png" alt="" />
                    </div>
                    <div class="ml-3 text-sm text-1c2129">官方网站</div>
                  </div>
                  <div
                    class="info-href height-40 rounded-md flex items-center"
                    @click="userToPageFunc('tsp-center')"
                  >
                    <div class="width-4 height-4 ml-3">
                      <img src="../assets/image/header/user-6.png" alt="" />
                    </div>
                    <div class="ml-3 text-sm text-1c2129">个人中心</div>
                  </div>
                  <div class="line-box"></div>
                  <div
                    class="text-sm text-86909c text-center pb-3 cursor-pointer exit-btn"
                    @click="exitFunc()"
                  >
                    退出登录
                  </div>
                </div>
              </template>
            </a-dropdown>
          </div>
          <!-- 未登录 -->
          <div v-else>
            <a-button
              class="height-36 mr-4 width-76 border-radius-6"
              @click="toRegisterFunc"
            >
              注册
            </a-button>
            <a-button
              type="primary"
              class="height-36 width-76 login-btn"
              @click="toLoginFunc"
            >
              登录
            </a-button>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>
<script setup lang="ts">
import dayjs from 'dayjs';
import { debounce } from 'lodash-es';
import { onMounted, reactive, ref, toRefs } from 'vue';

import { goLoginUrl, goLogOut, reUrlDelTicket } from '@/stores/ticketToToken';

import ImChat from '../components/im_chat/index.vue';
import { getLevelPrivilege, getMsgCount } from './../../api/user';
import { useUserStore } from './../../stores/user';
import {
  currEvn,
  getTalentDomain,
  transpaceDomain
} from './../../utils/http_help';
export interface TabsProps {
  stretch?: boolean;
}
const props = withDefaults(defineProps<TabsProps>(), {
  stretch: false
});
let userStore = useUserStore();
let userInfo = reactive({
  value: {} as any
});
let valMsgCount = reactive({
  value: {} as any
});
const state = reactive({
  projectLevel: {} as any,
  userLevel: {} as any
});
const { userLevel, projectLevel } = toRefs(state);

const herfObj: Record<string, string> = {
  'tw-home': '/go/tw_pc_login_option', // 孪生引擎
  'wd-home': '/go/wd_pc_login_option', // 云译客首页
  'wd-qz': '/go/wd_pc_login/circle/center', // 云译客圈子
  'wd-task': '/go/wd_pc_login/web/orders', // 任务中心
  'wd-task-center': '/go/wd_pc_login//task/center', // 订单广场
  'wd-set': '/go/wd_pc_login/users/likeSetting', // 接单设置
  'wp-recommendAll': '/go/wp_pc_login_option/chance/recommendAll', // 招募聚合页
  'wd-account': '/go/wd_pc_login/account/index', // 账户提现
  'wd-message': '/go/wd_pc_login/message/center', // 订单消息
  'tsp-help-center': '/helpCenter', // 帮助中心
  'wd-faq': '/go/wd_pc_login_option/about/faq', // 订单帮助
  'pe-personal': '/go/tsp_pc_login_option/personal', // 个人版
  'pe-team': '/go/tsp_pc_login_option/team', // 团队版
  'pe-recharge': '/go/wealth_pc_login/recharge', // 译力充值
  'pe-docs': '/go/pe_pc/docs/', // 工具帮助
  'iol-home': '/go/iollab_pc_login_option/home', // 翻译工具
  'wp-class': '/go/wp_pc_login_option/classIndex', // 课程
  'tsp-price': '/home/price', // 会员定价
  'tsp-version': '/version', // 版本动态
  'tsp-about': '/about', // 关于我们
  'tsp-im': '/home?openIm=1', // 工具消息
  'tsp-dashboard': '/dashboard', // 工作台
  'tsp-center': '/center', // 个人中心
  'tsp-activity': '/go/tsp_pc_login_option/activity', //活动中心
  'wd-square': '/go/wd_pc_login/web/square', //社区广场
  'wd-jl': '/go/wd_pc_login/web/userCenter/resume', // 个人简历
  'pe-invite-politely': '/go/pe_pc_login/pe?redirect=invitePolitely', // 邀请好友
  'tsp-home': '/home' // 官方网站
};
const scrollTop = ref(0);

interface SubNavItem {
  icon?: string;
  title?: string;
  description?: string;
  name?: string;
  list?: SubNavItem[];
}

interface NavItem {
  value: string;
  isTitle?: boolean;
  list?: SubNavItem[];
  more?: SubNavItem[];
  name?: string;
}

const data = ref<NavItem[]>([
  {
    value: '人机共译',
    isTitle: true,
    list: [
      {
        icon: 'https://ali-file-cdn.iol8.com/img/transpace/nav/header/header-1.png',
        title: '个人版',
        description: 'AI智能辅助，专注翻译',
        name: 'pe-personal'
      },
      {
        icon: 'https://ali-file-cdn.iol8.com/img/transpace/nav/header/header-2.png',
        title: '企业版',
        description: '多人合作，项目实时管理',
        name: 'pe-team'
      },
      {
        icon: 'https://ali-file-cdn.iol8.com/img/transpace/nav/header/header-3.png',
        title: '翻译工具',
        description: '语料对齐、术语提取等工具',
        name: 'iol-home'
      }
    ],
    more: [
      {
        icon: 'https://ali-file-cdn.iol8.com/img/transpace/nav/header/header-4.png',
        title: '会员定价',
        description: '专享高级功能与充值折扣',
        name: 'tsp-price'
      }
    ]
  },
  {
    value: '孪生引擎',
    isTitle: false,
    name: 'tw-home'
  },
  {
    value: '任务中心',
    isTitle: false,
    name: 'wd-task'
  },
  {
    value: '译客社区',
    isTitle: false,
    list: [
      {
        icon: 'https://ali-file-cdn.iol8.com/img/transpace/nav/header/header-5.png',
        title: '圈子',
        description: '加入译员专属圈子互动吧',
        name: 'wd-qz'
      },
      {
        icon: 'https://ali-file-cdn.iol8.com/img/transpace/nav/header/header-6.png',
        title: '课程',
        description: '翻译精品课程等你来学习',
        name: 'wp-class'
      },
      {
        icon: 'https://ali-file-cdn.iol8.com/img/transpace/nav/header/header-13.png',
        title: '活动中心',
        description: '最新精彩活动不要错过哦',
        name: 'tsp-activity'
      },
      {
        icon: 'https://ali-file-cdn.iol8.com/img/transpace/nav/header/header-14.png',
        title: '社区广场',
        description: '分享翻译心得抢专属红包',
        name: 'wd-square'
      }
    ]
  },
  {
    value: '关于我们',
    isTitle: false,
    list: [
      {
        icon: 'https://ali-file-cdn.iol8.com/img/transpace/nav/header/header-7.png',
        title: '版本动态',
        description: '快速了解产品更新内容',
        name: 'tsp-version'
      },
      {
        icon: 'https://ali-file-cdn.iol8.com/img/transpace/nav/header/header-8.png',
        title: '联系我们',
        description: '欢迎向我们咨询和反馈',
        name: 'tsp-about'
      },
      {
        icon: 'https://ali-file-cdn.iol8.com/img/transpace/nav/header/header-9.png',
        title: '帮助中心',
        description: '常见问题快速找到答案',
        name: 'tsp-help-center'
        // list: [
        //   {
        //     title: '订单帮助',
        //     name: 'wd-faq'
        //   },
        //   {
        //     title: '工具帮助',
        //     name: 'pe-docs'
        //   }
        // ]
      }
    ]
  }
]);

//location跳转
const toLinkFunc = (val: string) => {
  window.location.href = val;
};

// 菜单页面跳转
const toMenuPageFunc = (item: any, name: any) => {
  const twHomeUrl = `${transpaceDomain}${herfObj[name]}`;
  if (!item.list) {
    window.open(twHomeUrl, '_blank');
  } else {
    if (!name) return;
    if (name.includes('wd')) {
      window.location.href = twHomeUrl;
    } else {
      window.open(twHomeUrl, '_blank');
    }
  }
};
// 头像下拉内容跳转
const userToPageFunc = (name: any) => {
  const twHomeUrl = `${transpaceDomain}${herfObj[name]}`;
  if (name.includes('wd')) {
    window.location.href = twHomeUrl;
  } else {
    window.open(twHomeUrl, '_blank');
  }
};
const toHome = (tab: string | number) => {
  const twHomeUrl = `${transpaceDomain}/home/price?tab=${tab}`;
  window.open(twHomeUrl, '_blank');
};

// 登录
const toLoginFunc = () => {
  goLoginUrl();
};
// 注册
const toRegisterFunc = () => {
  let url = encodeURIComponent(location.origin);
  if (currEvn == 'dev') {
    window.location.href = `http://passport.dev.iol8.net/go/passport_pc/register?service=${url}`;
  } else if (currEvn == 'test') {
    window.location.href = `http://passport.qa.iol8.net/go/passport_pc/register?service=${url}`;
  } else if (currEvn == 'release') {
    window.location.href = `http://passport.release.iol8.net/go/passport_pc/register?service=${url}`;
  } else {
    window.location.href = `https://passport.iol8.com/go/passport_pc/register?service=${url}`;
  }
};
//退出登录
const exitFunc = () => {
  goLogOut();
};

onMounted(() => {
  reUrlDelTicket();
  if (userStore.trId) {
    userStore.getUserInfo().then((res: any) => {
      userInfo.value = res;
    });
    getMsgCount(userStore.trId).then((res: any) => {
      valMsgCount.value = res.data;
    });
    getLevelPrivilege().then((res: any) => {
      state.userLevel = res.data.personal;
      state.projectLevel = res.data.team;
    });
  }
  document.getElementsByTagName('body')[0].onscroll = debounce(function (e) {
    const top = e.target?.scrollingElement?.scrollTop || 0;
    scrollTop.value = top;
  }, 100);
});
</script>
<style src="./header.scss" scoped></style>
